module.exports = __webpack_public_path__ + "img/04-wide.d21a3dd4.svg";